<template>
  <div class="number-range">
    <el-input-number
      :value="numberRange[0] === null ? undefined : numberRange[0]"
      @input="$set(numberRange, 0, $event)"
      placeholder="最小值"
      :controls="false"
      :max="numberRange[1] === null ? Infinity : numberRange[1]"
      size="small"
      style="width: 40%"
    ></el-input-number>
    <span>-</span>
    <el-input-number
      :value="numberRange[1] === null ? undefined : numberRange[1]"
      @input="$set(numberRange, 1, $event)"
      placeholder="最大值"
      :controls="false"
      :min="numberRange[0] === null ? -Infinity : numberRange[0]"
      size="small"
      style="width: 40%"
    ></el-input-number>
    <div class="clear" v-if="numberRange[0] || numberRange[1]" @click="clearData">
      <i class="el-icon-circle-close"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "number-range",
  props: { numberRange: Array },
  methods: {
    clearData() {
      this.$emit("clear")
    }
  }
}
</script>

<style lang="scss" scoped>
.number-range {
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  justify-content: center;
  position: relative;
  &:hover {
    .clear {
      visibility: visible;
    }
  }
  .clear {
    color: #c0c4cc;
    visibility: hidden;
    position: absolute;
    right: 6px;
    cursor: pointer;
  }
  ::v-deep {
    .el-input--small {
      height: 30px;
    }
    .el-input__inner {
      border: unset;
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>
